import { render } from "./filtersLonja.vue?vue&type=template&id=13791321&scoped=true"
import script from "./filtersLonja.vue?vue&type=script&lang=js"
export * from "./filtersLonja.vue?vue&type=script&lang=js"

import "./filtersLonja.vue?vue&type=style&index=0&id=13791321&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13791321"]])

export default __exports__